<div class="flex  pt-[0px] h-[calc(90vh - 170px)]">
  <div class="w-[85%] ">
    <div id="section-project-design" class="section-color">
      <div class="">
        <app-stage3nav
          (navigateTab)="changeTab($event)"
          [currentTab]="selectedTab"
        ></app-stage3nav>
      </div>
      <div class="">
        <app-filter-tool></app-filter-tool>
      </div>
      <div class="flex justify-center mt-[-1px]">
        <!-- Wrapper for both sections -->
        <div class="main-section flex flex-col justify-between">
          <!-- Upper Section -->
          <div
            class="bg-white ml-[0px] mr-[0px] mb-[52px] h-[100%] rounded-[10px]"
            style="overflow-x: hidden"
          >

            <div
              class="card-container shadow-custom m-[22px] mr-0 bg-[#ffffff] rounded-lg"
            >
              <table class="w-full table-auto table-striped  mt-[10px]">
                <thead class="sticky top-0 bg-[#1A4971] !z-20 !h-[52px]">
                  <tr class="">
                 
                    <th class=" pl-10 !w-[15vw]">
                      <div class="flex">
                      <input
                      type="checkbox"
                      class="!mr-[10px] "
                      [checked]="selectAllChecked"
                      (change)="toggleSelectAll($event)"
                    />
                      <div
                        class="flex justify-start  items-center"
                        (click)="sortData('title')"
                      >
                     
                      {{selectedTab}} No.
                        <mat-icon>{{
                          sortColumn === "title"
                            ? sortDirection === "asc"
                              ? "arrow_upward"
                              : "arrow_downward"
                            : "arrow_downward"
                        }}</mat-icon>
                      </div>
                    </div>
                    </th>
                    <th class=" pl-10 !w-[20vw]">
                      <div
                        class="flex justify-start items-center"
                        (click)="sortData('title')"
                      >
                      {{selectedTab}} Title
                        <mat-icon>{{
                          sortColumn === "title"
                            ? sortDirection === "asc"
                              ? "arrow_upward"
                              : "arrow_downward"
                            : "arrow_downward"
                        }}</mat-icon>
                      </div>
                    </th>
                    <th class=" pl-10">
                      <div
                        class="flex justify-center items-center"
                        (click)="sortData('revision')"
                      >
                        Revision
                        <mat-icon>{{
                          sortColumn === "revision"
                            ? sortDirection === "asc"
                              ? "arrow_upward"
                              : "arrow_downward"
                            : "arrow_downward"
                        }}</mat-icon>
                      </div>
                    </th>
                    <th class=" pl-10" *ngIf="selectedTab === 'Drawing'">
                      <div
                        class="flex justify-start items-center"
                        (click)="sortData('title')"
                      >
                      {{selectedTab}} Date
                        <mat-icon>{{
                          sortColumn === "title"
                            ? sortDirection === "asc"
                              ? "arrow_upward"
                              : "arrow_downward"
                            : "arrow_downward"
                        }}</mat-icon>
                      </div>
                    </th>
                    <th class=" pl-10" *ngIf="selectedTab === 'Drawing'" >
                      <div
                        class="flex justify-start items-center"
                        (click)="sortData('title')"
                      >
                      Received Date
                        <mat-icon>{{
                          sortColumn === "title"
                            ? sortDirection === "asc"
                              ? "arrow_upward"
                              : "arrow_downward"
                            : "arrow_downward"
                        }}</mat-icon>
                      </div>
                    </th>
                    <th class=" pl-10"*ngIf="selectedTab === 'Drawing'">
                      <div
                        class="flex justify-left items-center"
                        (click)="sortData('preview')"
                      >
                        Set
                        <mat-icon>{{
                          sortColumn === "preview"
                            ? sortDirection === "asc"
                              ? "arrow_upward"
                              : "arrow_downward"
                            : "arrow_downward"
                        }}</mat-icon>
                      </div>
                    </th>

                    <th class="text-center pl-10">
                      <div
                        class="flex justify-center items-end"
                        (click)="sortData('action')"
                      >
                        Action
                        <!-- <mat-icon>{{
                          sortColumn === "action"
                            ? sortDirection === "asc"
                              ? "arrow_upward"
                              : "arrow_downward"
                            : "arrow_downward"
                        }}</mat-icon> -->
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let file of files">
                    <!-- Parent row -->
                    <tr *ngIf="file.parentable_id === null" class="hover:!bg-[#fae8e1]">
                      <td class="!text-center !text-[14px]">
                        <div class="flex items-center space-x-2">
                          <mat-icon class="cursor-pointer !h-[20px]" (click)="toggleAdvancedOptions(file.id)">
                            {{ isExpandedMap[file.id] ? 'expand_more' : 'chevron_right' }}
                          </mat-icon>
                          <input type="checkbox" (change)="toggleButtons($event, file.id)" [checked]="selectedFileIds.has(file.id)"/>
                          <span>{{file.sys_doc_no}}</span>
                        </div>
                      </td>
                      <td class="!text-start !text-[14px]">
                        {{ file.title }}
                      </td>
                      <td class="!text-center !text-[14px]">{{file?.revision || 1}}</td>
                      <td class="!text-center !text-[14px]" *ngIf="selectedTab === 'Drawing'">{{file?.default_date}}</td>
                      <td class="!text-center !text-[14px]" *ngIf="selectedTab === 'Drawing'">{{file?.publish_date}}</td>
                      <td class="!text-left !text-[14px]" *ngIf="selectedTab === 'Drawing'">
                        <a class="text-right !text-[16px] !w-[24px] h-[24px] text-[#000000]">
                          {{file?.drawing_set.set_name}}
                        </a>
                      </td>
                      <td>
                        <button [matMenuTriggerFor]="menu">
                          <mat-icon class="text-[#000000]" style=" font-size: 24px !important;">more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="downloadDocument(file.id,file.title)">
                            <mat-icon style="color: #E76B3F; font-size: 24px !important;">cloud_download</mat-icon>
                            <span style="margin-left: 10px;">Download</span>
                          </button>
                        </mat-menu>
                      </td>
                    </tr >
                    <!-- Child rows (shown when expanded) -->
                    <tr *ngIf="isExpandedMap[file.id] && file.children?.length">
                      <td colspan="7" class="">
                        <table class="w-full">
                          <tbody>
                            <tr *ngFor="let child of file.children" class="hover:!bg-[#fae8e1]">
                              <td class="!text-center !text-[14px] w-[14vw] max-!w-[15vw]">
                                <div class="flex items-center space-x-2 pl-4">
                                  <input type="checkbox" (change)="toggleButtons($event, child.id)" [checked]="selectedFileIds.has(child.id)"/>
                                  <span>{{child.sys_doc_no}}</span>
                                </div>
                              </td>
                              <td class="!text-start !text-[14px] !w-[20vw] max-!w-[21vw]">
                                {{ child.title }}
                              </td>
                              <td class="!text-center !text-[14px] !w-[18vw] max-!w-[19vw] ">{{child?.revision || 1}}</td>
                              <td class="!text-center !text-[14px] !w-[12vw]" *ngIf="selectedTab === 'Drawing'">{{child?.default_date}}</td>
                              <td class="!text-center !text-[14px] !w-[12vw]" *ngIf="selectedTab === 'Drawing'">{{child?.publish_date}}</td>
                              <td class="!text-left !text-[14px] !w-[12vw]" *ngIf="selectedTab === 'Drawing'">
                                {{file?.drawing_set.set_name}}
                              </td>
                              <td>
                                <button [matMenuTriggerFor]="childMenu">
                                  <mat-icon class="text-[#000000]" style="font-size: 24px !important;">more_vert</mat-icon>
                                </button>
                                <mat-menu #childMenu="matMenu">
                                  <button mat-menu-item (click)="downloadDocument(child.id,child.title)">
                                    <mat-icon style="color: #E76B3F; font-size: 24px !important;">cloud_download</mat-icon>
                                    <span style="margin-left: 10px;">Download</span>
                                  </button>
                                </mat-menu>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                       
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <ng-container *ngIf="isStageThreeSendForApproval; else sendForApproval">
      <app-project-stage-approval></app-project-stage-approval>
    </ng-container>
    <ng-template #sendForApproval>
      <app-sendforapproval
        [progress]="progress"
        [stage]="3"
      ></app-sendforapproval>
    </ng-template> -->
  </div>

  <div class="w-[15%] bg-[#F2F2F2] !p-[10px]">
      <div class="flex items-center justify-between">
        <button
        class="flex items-center !bg-[#E76B3F] !rounded-[3px] !text-white w-full h-[35px] !pl-[16px]"
        mat-button
        style="justify-content: flex-start;"
        (click)="openDialog()"
      >
        <div class="flex items-center space-x-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
            <path d="M14.577 4.60256C14.3306 2.02352 12.1935 0 9.56252 0C7.5267 0 5.78344 1.21406 4.98009 2.95608C4.73819 2.87862 4.48616 2.82608 4.21896 2.82608C2.82105 2.82608 1.68757 3.96553 1.68757 5.36953C1.68757 5.64875 1.74326 5.91273 1.82595 6.16312C0.738599 6.80015 0 7.96957 0 9.32494C0 11.3541 1.63698 12.9989 3.6565 12.9989V13H13.7815V12.9989C16.1127 12.9989 18 11.1014 18 8.75974C18 6.69329 16.5261 4.97675 14.577 4.60256ZM11.1264 7.85651H10.125V10.1242C10.125 10.4367 9.87415 10.6905 9.56252 10.6905H8.43748C8.12698 10.6905 7.87495 10.4367 7.87495 10.1242V7.85651H6.87306C6.26214 7.85651 6.01294 7.44673 6.31783 6.94709L8.44478 4.84056C8.86162 4.4223 9.12542 4.4082 9.55522 4.84056L11.6822 6.94709C11.9882 7.4473 11.7373 7.85651 11.1264 7.85651Z" fill="white"/>
          </svg>
          <span>Upload {{selectedTab}}</span>
        </div>
      </button>
      
      </div>
      <div>
        <div class="flex items-center justify-between !mt-[4px]">
          <button
            class="flex items-center !rounded-[3px] w-full h-[35px] !pl-[16px]"
            mat-button
            style="justify-content: flex-start;"
            [disabled]="selectedFileIds.size === 0"
            [ngClass]="selectedFileIds.size === 0 ? '!bg-gray-400 !text-gray-200'  : '!bg-[#E76B3F] !text-white' "
            (click)="downloadSelectedDocuments()"
            >
            <div class="flex items-center space-x-2">
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.577 4.99319C14.33 2.41414 12.193 0.390625 9.56252 0.390625C7.52614 0.390625 5.78344 1.60468 4.98009 3.34671C4.73762 3.26925 4.48616 3.21671 4.21896 3.21671C2.82105 3.21671 1.68757 4.35616 1.68757 5.76015C1.68757 6.03937 1.74326 6.30335 1.82595 6.55374C0.738033 7.19077 0 8.36019 0 9.71557C0 11.7447 1.63698 13.3895 3.6565 13.3895V13.3906H13.7821V13.3895C16.1127 13.3895 18 11.4921 18 9.15036C17.9994 7.08392 16.5261 5.36738 14.577 4.99319ZM11.6822 8.65579L9.55522 10.7623C9.12598 11.1947 8.86162 11.1806 8.44478 10.7623L6.31783 8.65579C6.01294 8.15558 6.26214 7.74637 6.87306 7.74637H7.87495V5.47872C7.87495 5.16618 8.12698 4.91238 8.43748 4.91238H9.56252C9.87358 4.91238 10.125 5.16618 10.125 5.47872V7.74637H11.1258C11.7367 7.74637 11.9876 8.15558 11.6822 8.65579Z" fill="white"/>
                </svg>
                
              <span>Download {{selectedTab}}</span>
            </div>
          </button>
        </div>
      
        <div class="flex items-center justify-between !mt-[4px]">
          <button
            class="flex items-center !rounded-[3px] w-full h-[35px] !pl-[16px]"
            mat-button
            style="justify-content: flex-start;"
            [disabled]="selectedFileIds.size === 0"
            [ngClass]="selectedFileIds.size === 0 ? '!bg-gray-400 !text-gray-200'  : '!bg-[#E76B3F] !text-white' "
          >
            <div class="flex items-center space-x-2">
              <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.92073 7.90386C9.49779 8.17275 9.00651 8.31489 8.5 8.31489C7.99352 8.31489 7.50225 8.17275 7.0793 7.90386L0.113189 3.475C0.0747337 3.45048 0.0369897 3.42496 0 3.39847L0 10.6556C0 11.4877 0.708057 12.148 1.56496 12.148H15.435C16.3075 12.148 17 11.4728 17 10.6556V3.39844C16.9629 3.425 16.9251 3.45057 16.8865 3.47513L9.92073 7.90386Z" fill="white"/>
                <path d="M0.665723 2.67847L7.63184 7.10737C7.89554 7.27502 8.19775 7.35884 8.49997 7.35884C8.80222 7.35884 9.10446 7.27499 9.36816 7.10737L16.3343 2.67847C16.7511 2.41361 17 1.97032 17 1.49189C17 0.669239 16.2982 0 15.4356 0H1.56443C0.701815 3.16634e-05 8.23472e-07 0.66927 8.23472e-07 1.49268C-0.000257782 1.72737 0.0603975 1.95847 0.176557 2.16538C0.292716 2.37228 0.460768 2.54856 0.665723 2.67847Z" fill="white"/>
                </svg>
                
              <span>Email {{selectedTab}}</span>
            </div>
          </button>
        </div>
      
        <div class="flex items-center justify-between !mt-[4px]">
          <button
            class="flex items-center !rounded-[3px] w-full h-[35px] !pl-[16px]"
            mat-button
            style="justify-content: flex-start;"
            [disabled]="selectedFileIds.size === 0"
            [ngClass]="selectedFileIds.size === 0 ? '!bg-gray-400 !text-gray-200'  : '!bg-[#E76B3F] !text-white' "
          >
            <div class="flex items-center space-x-2">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7759_60832)">
                <path d="M9.26331 2.51562L1.0101 10.7694C0.968576 10.8111 0.938595 10.8637 0.924318 10.9202L0.00952848 14.5919C-0.0178355 14.7025 0.0146444 14.82 0.0953086 14.9007C0.156342 14.9617 0.239505 14.9955 0.324571 14.9955C0.350626 14.9955 0.377277 14.9923 0.403213 14.9857L4.07498 14.0708C4.13221 14.0566 4.1842 14.0267 4.22572 13.9852L12.4796 5.73196L9.26331 2.51562Z" fill="white"/>
                <path d="M14.5252 1.39464L13.6065 0.47592C12.9924 -0.138104 11.9223 -0.137509 11.309 0.47592L10.1836 1.60129L13.3998 4.81751L14.5252 3.69214C14.8319 3.38554 15.0008 2.97746 15.0008 2.54345C15.0008 2.10943 14.8319 1.70135 14.5252 1.39464Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_7759_60832">
                <rect width="15" height="15" fill="white"/>
                </clipPath>
                </defs>
                </svg>
                
                
              <span>Bulk Edit</span>
            </div>
          </button>
        </div>
      
        <div class="flex items-center justify-between !mt-[4px]">
          <button
            class="flex items-center !rounded-[3px] w-full h-[35px] !pl-[16px]"
            mat-button
            style="justify-content: flex-start;"
            [ngClass]="selectedFileIds.size === 0 ? '!bg-gray-400 !text-gray-200'  : '!bg-[#E76B3F] !text-white' "
            (click)="deleteSelectedFiles()"
            [disabled]="selectedFileIds.size === 0"
          >
            <div class="flex items-center space-x-2">
              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.06445 5.27344L2.94663 16.5493C3.00985 17.3624 3.66401 18 4.43492 18H12.5632C13.3341 18 13.9883 17.3624 14.0515 16.5493L14.9337 5.27344H2.06445ZM6.00835 15.8906C5.74764 15.8906 5.5283 15.6759 5.51177 15.3962L5.01372 6.88841C4.99669 6.59746 5.20534 6.34718 5.47966 6.32914C5.76418 6.30802 5.99036 6.53154 6.00786 6.82249L6.5059 15.3303C6.52353 15.6316 6.29838 15.8906 6.00835 15.8906ZM8.9971 15.3633C8.9971 15.6548 8.77434 15.8906 8.49905 15.8906C8.22377 15.8906 8.00101 15.6548 8.00101 15.3633V6.85547C8.00101 6.56399 8.22377 6.32812 8.49905 6.32812C8.77434 6.32812 8.9971 6.56399 8.9971 6.85547V15.3633ZM11.9844 6.88845L11.4863 15.3963C11.47 15.6731 11.2521 15.9038 10.9581 15.8896C10.6838 15.8716 10.4752 15.6213 10.4922 15.3303L10.9902 6.82253C11.0073 6.53157 11.248 6.3199 11.5184 6.32918C11.7928 6.34721 12.0014 6.59749 11.9844 6.88845Z" fill="white"/>
                <path d="M14.9746 2.10938H11.9863V1.58203C11.9863 0.709664 11.3161 0 10.4922 0H6.50781C5.68391 0 5.01367 0.709664 5.01367 1.58203V2.10938H2.02539C1.47525 2.10938 1.0293 2.58156 1.0293 3.16406C1.0293 3.7465 1.47525 4.21875 2.02539 4.21875C6.60629 4.21875 10.3939 4.21875 14.9746 4.21875C15.5248 4.21875 15.9707 3.7465 15.9707 3.16406C15.9707 2.58156 15.5248 2.10938 14.9746 2.10938ZM10.9902 2.10938H6.00977V1.58203C6.00977 1.29108 6.23302 1.05469 6.50781 1.05469H10.4922C10.767 1.05469 10.9902 1.29108 10.9902 1.58203V2.10938Z" fill="white"/>
                </svg>
                
              <span>Delete {{selectedTab}}</span>
            </div>
          </button>
        </div>
      </div>
      <div class="bg-white shadow-md p-[10px] mt-[10px]" *ngIf="selectedTab === 'Drawing'"> 
        <div class="flex justify-between items-center">
            <h2 class="!text-[1rem] font-normal !m-0">Revision 1</h2>
            <mat-icon>close</mat-icon>
        </div>
        <p class="text-gray-600 !m-0">Ready for Review</p>
        <p class="text-gray-500 text-sm">18 sheets require your attention</p>
        <div class="flex space-x-2 mt-2">
          <div class="h-2 bg-green-300 rounded-full flex-1" [style.width.%]="progress1"></div>
          <div class="h-2 bg-green-400 rounded-full flex-1" [style.width.%]="progress2"></div>
          <div class="h-2 bg-green-500 rounded-full flex-1" [style.width.%]="progress3"></div>
      </div>
      
        <div class="mt-4">
            <a  class="text-red-500 underline text-[12px]  !text-center cursor-pointer" (click)="handleRevision()">Click here to review</a>
        </div>      
      </div>
      <div>
        <!-- <h3>{{selectedTab}} Reports</h3> -->
        <h3>{{formattedSelectedTab}} REPORTS</h3>
        <h6>All Sets & Revisions</h6>
        <h6>Sketches</h6>
        <h6>Delete {{selectedTab}} Revisions</h6>
        <h6>Measurements</h6>
      </div>

  </div>
</div>
